
import { createContext, useContext, useState, useEffect } from 'react';
import { sessionManager } from '../Config/cookies';
import { logoutUser } from '../API';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const session = sessionManager.restoreSession();

    if (session) {
      
      setUser(session.userData);
      setIsAuthenticated(true);
    } else {
      
      setUser(null);
      setIsAuthenticated(false);
    }

    setLoading(false); 
  }, []);

  useEffect(() => {
    const handleSessionExpired = () => {
      ('🔄 انتهاء الجلسة');
      sessionManager.clearSession();
      setUser(null);
      setIsAuthenticated(false);
      window.location.href = '/login';
    };

    window.addEventListener('sessionExpired', handleSessionExpired);
    return () => {
      window.removeEventListener('sessionExpired', handleSessionExpired);
    };
  }, []);

  const login = (response) => {
    sessionManager.saveSession(response);
    const userInfo = {
      id: response.user.id,
      first_name: response.user.first_name,
      last_name: response.user.last_name,
      is_active: response.user.is_active,
      role: response.user.role
    };
    setUser(userInfo);
    setIsAuthenticated(true);
  };

  const logout = async () => {
    try {
      await logoutUser();
    } catch (error) {
      console.warn('فشل تسجيل الخروج:', error.message);
    }

    sessionManager.clearSession();
    setUser(null);
    setIsAuthenticated(false);
    window.location.href = '/login';
  };

  const clearSession = async () => {
    try {
      await logoutUser();
    } catch {}
    sessionManager.clearSession();
    setUser(null);
    setIsAuthenticated(false);
    window.location.href = '/login';
  };

  const getAccessToken = () => {
    return sessionManager.restoreSession()?.accessToken;
  };

  const getRefreshToken = () => {
    return sessionManager.restoreSession()?.refreshToken;
  };

  const value = {
    user,
    isAuthenticated,
    loading, 
    login,
    logout,
    clearSession,
    getAccessToken,
    getRefreshToken
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};



